import { Select } from '../../../../Toolkit/Inputs/Select';
import type { SelectProps } from '../../../../Toolkit/Inputs/Select';

export interface FixedSelectProps
  extends Omit<SelectProps, 'value' | 'options' | 'onChange'> {
  readonly onChange: (val: string | null) => void;
  readonly value: string | null;
  readonly options: Array<{
    value: string | null;
    label: string;
  }>;
}

/**
 * A select component that handles null value instead of 'placeholder'.
 */
export default function FixedSelect({
  value,
  options,
  onChange,
  ...props
}: FixedSelectProps) {
  return (
    <Select
      {...props}
      value={value ?? 'placeholder'}
      options={options?.map((option) => ({
        ...option,
        value: option.value ?? 'placeholder',
      }))}
      onChange={
        onChange === undefined
          ? undefined
          : (val) => {
              onChange(val === 'placeholder' ? null : val);
            }
      }
      {...props}
    />
  );
}
